import registerBuiltinStores from './registerBuiltinStores';

registerBuiltinStores();
